<template>
    <div class="error-404">
        <icon type="chucuola" width="200" height="200"></icon>
        <p>{{ $t('i18n.404') }}</p>
        <p>
            <router-link to="/">
                {{ $t('i18n.backHome') }} (
                <countdown :time="5000" @end="handleCountdownEnd">
                    <template slot-scope="props">{{ props.totalSeconds }}</template>
                </countdown>)
            </router-link>
        </p>
    </div>
</template>

<script>
export default {
    methods: {
        handleCountdownEnd() {
            this.$router.push({
                name: 'home'
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.error-404 {
    position: relative;
    text-align: center;
    top: 50%;
    transform: translateY(-50%);

    a {
        font-size: 12px;
    }
}
</style>
